export const marketingPagePaths = [
  '/',
  '/about',
  '/contact',
  '/faq',
  '/terms',
  '/privacy',
  '/cookies',
] as const;

export type MarketingPagePath = (typeof marketingPagePaths)[number];

const metadata: Record<
  MarketingPagePath,
  { title: string; description: string }
> = {
  '/': {
    title: 'DirectorDeck — Create Cinematic Presentations',
    description:
      'Create and transform presentations with DirectorDeck. Shape your story, refine the design, and bring your slides to life with cinematic motion.',
  },
  '/about': {
    title: 'About DirectorDeck — Cinematic Presentations',
    description:
      'Learn about DirectorDeck and our approach to turning ideas and ordinary slides into cinematic presentations for speakers and teams.',
  },
  '/contact': {
    title: 'Contact DirectorDeck — Support and Product Questions',
    description:
      'Contact DirectorDeck for product questions, presentation support, and help getting started. Connect with the team or request a personal tour.',
  },
  '/faq': {
    title: 'DirectorDeck FAQ — Presentations, Studio, and Credits',
    description:
      'Find answers to common DirectorDeck questions about creating presentations, supported files, cinematic transitions, Studio subscriptions, and credits.',
  },
  '/terms': {
    title: 'Terms of Service — DirectorDeck',
    description:
      'Read the DirectorDeck Terms of Service covering use of the presentation platform, accounts, subscriptions, intellectual property, and responsibilities.',
  },
  '/privacy': {
    title: 'Privacy Policy — DirectorDeck',
    description:
      'Read the DirectorDeck Privacy Policy to understand how personal information and presentation data are collected, used, stored, and protected.',
  },
  '/cookies': {
    title: 'Cookie Policy — DirectorDeck',
    description:
      'Read the DirectorDeck Cookie Policy for information about cookies and similar technologies used on the website and your available choices.',
  },
};

export function getMarketingMetadata(
  pathname: MarketingPagePath,
  siteUrl?: string,
) {
  let origin: string | undefined;
  try {
    const url = new URL(siteUrl ?? '');
    if (
      ['https:', 'http:'].includes(url.protocol) &&
      !url.username &&
      !url.password
    ) {
      origin = url.origin;
    }
  } catch {
    // Local builds without a configured origin must not invent canonical URLs.
  }
  return {
    ...metadata[pathname],
    canonical: origin ? new URL(pathname, origin).href : undefined,
    image: origin
      ? new URL(
          '/landing/assets/decks/hudson-spire-progress-report-poster.jpg',
          origin,
        ).href
      : undefined,
    origin,
  };
}
